import React, { useState, useMemo } from 'react';
import { formatDistanceToNow, compareDesc } from 'date-fns';
import { es } from 'date-fns/locale';
// import Inputmask from 'inputmask';
import VocationStartLogo from '../img/vocation_start_logo.png';
import VocationJuniorLogo from '../img/vocation_junior_logo.png';
import VocationOneLogo from '../img/vocation_one_logo.png';

import {
  Form,
  FormInput,
  SchoolInfoWrapper,
  Row,
  Col,
  Footer,
  ErrorMessage
} from './login.styles';
import { useDataContext } from '../../../../Context/campaign-context';

const getQuery = param => {
  if (!param) {
    return null;
  }
  const query = new URLSearchParams(window.location.search);
  const result = query.get(param);
  return result;
};

const LoginBox = props => {
  const { SKU } = props;
  const [error, setError] = useState('');
  const [rut, setRut] = useState('');
  const {
    campaign,
    setUserData,
    loadingUser,
    setPrevResponses,
    logInUser
  } = useDataContext();

  console.log({ campaign });

  // const inputEl = useRef(null);

  // // De forma similar a componentDidMount y componentDidUpdate
  // useEffect(() => {
  //   // Actualiza el título del documento usando la API del navegador
  //   if (inputEl.current) {
  //     Inputmask({
  //       mask: '99.999.999-9',
  //       numericInput: true,
  //       jitMasking: true
  //     }).mask(inputEl);
  //   }
  // }, []);

  const onSubmit = async e => {
    e.preventDefault();
    // console.log('submitting', rut);
    const lowerRut = rut.toLowerCase().trim(); // lower case rut
    const cleanRut = lowerRut.replace(/_/g, ''); // clean "_" chars from rut.
    // console.log({ rut, cleanRut });
    // LOGIN LOGIC!!!
    // console.log('now login on campaign with this rut');
    let currentUser = {};
    let prevResponses = [];
    // console.log({ campaign });
    const isClosed = campaign.type === 'closed';
    const isOpened = campaign.type === 'opened';
    const isMixed = campaign.type === 'mixed';

    // check if closed and no participant to return early
    if (isClosed) {
      // console.log('is closed, has to logIn');
      const { participant, responses } = await logInUser({
        field: 'rut',
        value: cleanRut
      });
      // console.log({ participant })
      // console.log({ responses })
      if (!participant) {
        // return early
        return setError(
          `No se encontró participante con Código Acceso: ${cleanRut}`
        );
      }
      currentUser = { ...participant, rut: cleanRut }; // login logic has user object with responseID ??
      if (responses) {
        prevResponses = responses;
      }
    }

    if (isOpened) {
      // set local user only with rut and continue
      currentUser = { rut: cleanRut }; // login logic has user object with responseID ??
    }

    if (isMixed) {
      // console.log('is mixed, has to logIn and continue regardless');
      const { participant, responses } = await logInUser({
        field: 'rut',
        value: cleanRut
      });
      if (!participant) {
        currentUser = { rut: cleanRut };
      }
      if (participant) {
        currentUser = { ...participant, rut: cleanRut }; // login logic has user object with responseID ??
      }
      if (responses) {
        prevResponses = responses;
      }
    }

    const CURRENT_CODE = `currentCode_${campaign.id}`;
    const LOCAL_RESPONSES = `localUserResponses_${campaign.id}`;
    const localList = localStorage.getItem(LOCAL_RESPONSES);
    // if responses list, check if current rut has local responseID to continue
    if (localList) {
      const campaignResponseLists = JSON.parse(localList);
      const currUserResponse = campaignResponseLists[cleanRut];
      if (currUserResponse) {
        currentUser = { ...currentUser, responseID: currUserResponse };
      }
    }
    // set responseID from url to continue prev incomplete data
    const urlResponseID = getQuery('rid');
    if (urlResponseID) {
      currentUser = { ...currentUser, responseID: urlResponseID };
    }
    // console.log({ currentUser });
    localStorage.setItem(CURRENT_CODE, cleanRut);
    localStorage.setItem(
      `localUserData_${campaign.id}`,
      JSON.stringify(currentUser)
    );

    // console.log({ prevResponses })
    await setPrevResponses(prevResponses);
    await setUserData(currentUser);
  };

  // console.log({ campaign });

  const timeDistanceString = useMemo(() => {
    if (campaign.openedAt) {
      return formatDistanceToNow(new Date(campaign.openedAt), {
        addSuffix: true,
        locale: es
      });
    }
  }, [campaign]);

  const isOpenedDate = useMemo(() => {
    if (campaign.openedAt) {
      // console.log({ openedAt: new Date(campaign.openedAt) });
      // console.log({ now: new Date() });
      const result = compareDesc(new Date(campaign.openedAt), new Date());
      // console.log({ result });
      return result !== -1; // if not -1, is opened
    }
    // defaults to true if no openedAt value
    return true;
  }, [campaign]);

  // console.log({ isOpenedDate, timeDistanceString });

  const isPublishedAndDateNotPassed =
    campaign.status === 'published' && !isOpenedDate;
  const isPublishedAndDatePassed =
    campaign.status === 'published' && isOpenedDate;
  // console.log({ isPublishedAndDatePassed, isPublishedAndDateNotPassed });

  return (
    <Row>
      {SKU === 'VOCATION_ONE' && <VocationOneIntro />}
      {SKU === 'VOCATION_JUNIOR' && <VocationJuniorIntro />}
      {SKU === 'VOCATION_START' && <VocationStartIntro />}
      <Col>
        {campaign?.metadata?.logo && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              paddingBottom: '1rem',
              marginTop: '-1rem'
            }}
          >
            <img
              src={campaign.metadata.logo}
              alt='campaign logo'
              style={{ maxWidth: '200px', maxHeight: '100px' }}
            />
          </div>
        )}

        {isPublishedAndDateNotPassed && (
          <Form onSubmit={() => {}}>
            <FormInput>
              <SchoolInfoWrapper>
                <div>{campaign.organization || campaign.title}</div>
              </SchoolInfoWrapper>
            </FormInput>
            <FormInput>
              <p>
                Este acceso estará disponible{' '}
                <strong>{timeDistanceString}</strong>.
              </p>
            </FormInput>
          </Form>
        )}
        {isPublishedAndDatePassed && (
          <Form onSubmit={onSubmit}>
            <FormInput>
              <SchoolInfoWrapper>
                <div>{campaign.organization || campaign.title}</div>
              </SchoolInfoWrapper>
            </FormInput>
            <FormInput>
              <label htmlFor='rutid'>Ingresa tu Rut (o código de acceso)</label>
              <input
                // ref={inputEl}
                name='rutid'
                value={rut}
                onChange={e => setRut(e.target.value)}
              />
              {/* <p>
                <strong>Importante: </strong>
                Ingresa tu RUT <u>sin puntos ni guión</u>. <br />
                En caso que termine en <em>K</em> reemplázalo por un <em>0</em>.
              </p> */}
            </FormInput>
            {error && <ErrorMessage>{error}</ErrorMessage>}
            <Footer>
              <button type='submit' disabled={loadingUser}>
                {loadingUser ? 'Ingresando...' : 'Ingresar'}
              </button>
            </Footer>
          </Form>
        )}
        {campaign.status === 'unpublished' && (
          <Form onSubmit={() => {}}>
            <FormInput>
              <SchoolInfoWrapper>
                <div>{campaign.organization || campaign.title}</div>
              </SchoolInfoWrapper>
            </FormInput>
            <FormInput>
              <p>Campaña no disponible</p>
            </FormInput>
          </Form>
        )}
        {campaign.status === 'paused' && (
          <Form onSubmit={() => {}}>
            <FormInput>
              <SchoolInfoWrapper>
                <div>{campaign.organization || campaign.title}</div>
              </SchoolInfoWrapper>
            </FormInput>
            <FormInput>
              <p>Campaña pausada</p>
            </FormInput>
          </Form>
        )}
      </Col>
      <div>
        <div className='bl' />
        <div className='tr' />
      </div>
    </Row>
  );
};
export default LoginBox;

const VocationOneIntro = () => (
  <Col>
    <div className='logo-wrapper'>
      <img src={VocationOneLogo} alt='vocation one logo' />
    </div>
    <br />
    <div className='vocation-info'>
      <p>
        Bienvenido a <strong>Vocation One</strong>. Ingresa tu{' '}
        <em>Código de Acceso</em> a continuación.
      </p>
      <p>
        Esta información solo se utilizará para guardar los avances de esta
        encuesta en este dispositivo o computadora, y es requisito para poder
        registrar cada una de tus respuestas.
      </p>
      <p>
        En caso de necesitarlo, puedes retomar tus avances volviendo a
        introducir tu <em>Código de Acceso</em> en esta encuesta.
      </p>
      <p>
        Si tienes alguna pregunta o deseas ponerte en contacto con nosotros,
        puedes contactar a EduMetrics al email{' '}
        <a href={`mailto:contacto@edumetrics.cl`}>contacto@edumetrics.cl</a>.
      </p>
    </div>
  </Col>
);

const VocationJuniorIntro = () => (
  <Col>
    <div className='logo-wrapper'>
      <img src={VocationJuniorLogo} alt='vocation junior logo' />
    </div>
    <br />
    <div className='vocation-info'>
      <p>
        Bienvenido a <strong>Vocation Junior</strong>. Ingresa tu{' '}
        <em>Código de Acceso</em> a continuación.
      </p>
      <p>
        Esta información solo se utilizará para guardar los avances de esta
        encuesta en este dispositivo o computadora, y es requisito para poder
        registrar cada una de tus respuestas.
      </p>
      <p>
        En caso de necesitarlo, puedes retomar tus avances volviendo a
        introducir tu <em>Código de Acceso</em> en esta encuesta.
      </p>
      <p>
        Si tienes alguna pregunta o deseas ponerte en contacto con nosotros,
        puedes contactar a EduMetrics al email{' '}
        <a href={`mailto:contacto@edumetrics.cl`}>contacto@edumetrics.cl</a>.
      </p>
    </div>
  </Col>
);

const VocationStartIntro = () => (
  <Col>
    <div className='logo-wrapper'>
      <img src={VocationStartLogo} alt='vocation start logo' />
    </div>
    <br />
    <div className='vocation-info'>
      <p>
        Bienvenido a <strong>Vocation Start</strong>. Ingresa tu{' '}
        <em>Código de Acceso</em> a continuación.
      </p>
      <p>
        Esta información solo se utilizará para guardar los avances de esta
        encuesta en este dispositivo o computadora, y es requisito para poder
        registrar cada una de tus respuestas.
      </p>
      <p>
        En caso de necesitarlo, puedes retomar tus avances volviendo a
        introducir tu <em>Código de Acceso</em> en esta encuesta.
      </p>
      <p>
        Si tienes alguna pregunta o deseas ponerte en contacto con nosotros,
        puedes contactar a EduMetrics al email{' '}
        <a href={`mailto:contacto@edumetrics.cl`}>contacto@edumetrics.cl</a>.
      </p>
    </div>
  </Col>
);
